import { pt } from '../copy';

type CostDisclosureProps = {
  years: number[];
  quality: 'high' | 'medium';
};

const USD_FORMATTER = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
});

export default function CostDisclosure({ years, quality }: CostDisclosureProps) {
  const unitCost = quality === 'high' ? 0.2 : 0.1;
  const estimate = years.length * unitCost;

  return (
    <div className="flex items-center justify-between gap-4 rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white/80">
      <div className="space-y-1">
        <span className="block">{pt.costDisclosureLabel}</span>
        <span className="block text-xs text-white/45">{pt.costDisclosureValue}</span>
      </div>
      <strong className="text-white">{USD_FORMATTER.format(estimate)}</strong>
    </div>
  );
}
